export const cssEaseInOutCirc = `cubic-bezier(0.85, 0, 0.15, 1)`;
export const cssEaseOutExpo = `cubic-bezier(0.16, 1, 0.3, 1)`;
export const easeOutExpo = [0.16, 1, 0.3, 1];
export const easeInOutCirc = [0.85, 0, 0.15, 1];
export const easeInExpo = [0.7, 0, 0.84, 0];
